<svelte:options customElement={{ tag: "bt-link-button", shadow: "none", }} />

<script lang="ts">
	export let link = '/';
	export let text = '';

	let linkEl: HTMLElement | null = null;

	const handleClick = () => {
		if (linkEl) {
			linkEl.style.pointerEvents = 'none';
		}
	}
</script>


<a href="{link}" bind:this={linkEl} on:click={handleClick}>
		{text}
</a>

<style>
  a {
    white-space: nowrap;
    max-width: theme('screens.sm');
    padding: 0.625rem theme('padding.6');
    background: theme('colors.neutral.900');
    border: 1px solid theme('colors.neutral.900');
    color: white;
    font-size: theme('fontSize.sm');
    border-radius: 4px;
    transition: all 100ms ease-in-out;
    &:hover {
    	background: transparent;
    	color: theme('colors.neutral.900');
    }
  }
  @media print {
    a {
      display: none !important;
    }
  }
</style>
